export default (name) => {
  let capitalizedName = '';
  let nameSplit = name.split(/\W/g);
  let symbols = name.match(/\W/g);

  nameSplit.forEach((ele, i) => {
    capitalizedName += nameSplit[i][0].toUpperCase() + nameSplit[i].slice(1)
    if(i < nameSplit.length -1)  capitalizedName += symbols[i];
  })

  return capitalizedName
}


// WEBPACK FOOTER //
// ./src/features/contests/util/capitalizeWords.js